import BarrelOnboardingType from "../../api/model/barrels/BarrelOnboardingType";

export default function trackOnboardingProjectEvent(
    guideStepName: string,
    onboardingType: BarrelOnboardingType | undefined
) {
    /**
     * This function expects `onboardingType` to be defined,
     * but its type is reflected from Barrel model as `BarrelOnboardingType | undefined`.
     * This check is not required but gives us a safety against tracking wrong events by mistake.
     */
    if (!onboardingType) {
        return;
    }

    const guideFlowType = onboardingType === BarrelOnboardingType.Figma
        ? "Figma Sample Project"
        : "Sample Project";

    mixpanel.master.track("Clicked on user guide", {
        "Guide Flow Type": guideFlowType,
        "Guide Step Name": guideStepName
    });
}
